module.exports = __webpack_public_path__ + "static/media/dollar.04cee1f1.svg";